import { useCallback, useEffect, useState, FC } from 'react';
import { Button, Container } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import XLSX from "xlsx";

//Components
import ActivityModal from '../common/ActivityModal';
import ActivityTable from '../common/ActivityTable';

//Icons
import ActivityLoading from '../common/ActivityLoading';

//Services
import { removeUsersFromActivity } from '../../services/ActivityService';
import { getUserByActivityId } from '../../services/NewGroupService';

//Types
import { ModalOptionsInterface, TableColumnInterface, TableOptionsInterface } from '../common/Types';

//Styles
import '../common/styles.scss';

const ActivityReport: FC = (props: any) => {
    const { location } = props;

    const [modal, setModal] = useState<ModalOptionsInterface>({ open: false, header: "", body: null, buttons: [] });
    const [selectedUsers, setSelectedUsers] = useState<Array<string>>([]);
    const [students, setStudents] = useState<Array<any>>([]);
    const [loading, setLoading] = useState(false);

    const history = useHistory();

    const fetchStudents = useCallback(() => {
        const state = location.state ? location.state : undefined;
        if (state !== undefined) {
            const id = state.data.id;
            getUserByActivityId(id).then((response: any) => {
                setStudents(response as Array<any>)
                setLoading(false);
            })
        }
    }, [location])

    useEffect(() => {
        setLoading(true);
        fetchStudents();
    }, [fetchStudents])

    const exportCsv = () => {
        const state = location.state ? location.state : undefined;
        let nameActivity = '';
        if (state !== undefined)
            nameActivity = state.data.name;

        let arrData = students;
        arrData.forEach((data) => {
            delete data.phoneNumber;
            delete data.providerId;
            delete data.student;
            delete data.admin;
            delete data.teacher;
            delete data.providerId;
            delete data.photoURL;
        });

        let ws = XLSX.utils.json_to_sheet(arrData, {});
        let wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
        let exportFileName = 'Lista_Estudiantes_Curso_' + nameActivity + '.csv';
        XLSX.writeFile(wb, exportFileName);
    }

    const tableColumns: Array<TableColumnInterface> = [
        { title: "Clave", value: "code" },
        { title: "Nombre", value: "displayName" },
        { title: "Correo electrónico", value: "email" },
    ]

    const handleMultiSelect = (id: string, value: boolean) => {
        let selected = [...selectedUsers];

        if (value) {
            selected.push(id);
        } else {
            selected = selected.filter((sel) => sel !== id);
        }

        setSelectedUsers(selected);
    }

    const handleDisableMultiUsers = () => {
        setModal({
            open: true,
            header: "Borrar",
            body: <div>
                <span>{"Estas seguro de que quieres borrar los usuarios seleccionados?"}</span>
            </div>,
            buttons: [
                { text: "Borrar", func: () => disableUsers() },
                { text: "Cancel", func: handleModalClose }
            ]
        });
    }

    const disableUsers = () => {
        const state = location.state ? location.state : undefined;

        if (state !== undefined) {
            setLoading(true);
            const activityId = state.data.id;

            removeUsersFromActivity(activityId, selectedUsers)
                .then(() => {
                    // setLoading(false);
                    setSelectedUsers([]);
                    handleModalClose();
                    fetchStudents();
                })
        }
    }

    const handleModalClose = () => {
        setModal({ open: false, header: "", body: "", buttons: [] });
    }

    const tableOptions: TableOptionsInterface = {
        multiSelect: {
            key: "email",
            values: selectedUsers,
            func: (id: string, value: boolean) => handleMultiSelect(id, value)
        }
    }

    if (loading) return <ActivityLoading />
   
    return (
        <Container>
            <div style={{ marginBottom: '10px' }}>
                <h1>{`Reporte ${location.state.data.name}`}</h1>
            </div>
            <ActivityModal {...modal} onClose={handleModalClose} />
            <div style={{ marginBottom: '15px' }}>
                <Button variant="outline-primary" onClick={() => history.goBack()}>Regresar</Button>
                <Button variant="outline-primary" disabled={students.length === 0 ? true : false} style={{ marginLeft: '10px' }} onClick={() => exportCsv()}>Exportar CSV</Button>
                <Button disabled={!selectedUsers} variant="outline-danger" onClick={() => handleDisableMultiUsers()} style={{ marginLeft: '10px' }}>Borrar usuarios</Button>
            </div>
            <ActivityTable data={students ? students : []} columns={tableColumns} options={tableOptions} />
        </Container>
    )
}

export default ActivityReport;
